import Icon from 'veui/components/Icon'
import { IconFileEdit } from 'dls-icons-vue'

Icon.register('file-edit', IconFileEdit)
